// extracted by mini-css-extract-plugin
export default {"root":"_3CbA4","custom-icon-button-size":"_1nwSH","customIconButtonSize":"_1nwSH"};